import { JnsLink } from "./typography/JnsLink"
import { Text, TextProps } from "@chakra-ui/react";

export const Copyright = (props: TextProps) => {
  return (
    <Text fontSize="12px" lineHeight="16px" color="white" {...props}>
      Copyright © 2023-2024. All rights reserved. Created by <JnsLink to="https://atcontent.fi/" target="_blank">All Things Content</JnsLink> and <JnsLink to="https://www.indevit.fi/" target="_blank">Indevit</JnsLink>
    </Text>
  )
}